export const GET_USER_RENEWAL_NOTIFICATION =
  '/api/User/get-user-renewal-notification';

export const ACCEPT_RENEWAL_NOTIFICATION =
  '/api/User/accept-renewal-notification';

export const CREATE_RENEWAL_NOTIFICATION =
  '/api/User/create-renewal-notification';

export const CLONE_RENEWAL_NOTIFICATION =
  '/api/User/clone-renewal-notification';

export const DELETE_RENEWAL_NOTIFICATION =
  '/api/User/delete-renewal-notification';

export const GET_RENEWAL_NOTIFICATION_GRID =
  '/api/User/get-renewal-notification-grid';

export const GET_RENEWAL_NOTIFICATION_SHORT_CONTENT =
  '/api/User/get-renewal-notification-short-content';

export const GET_RENEWAL_NOTIFICATION_GRID_DISTINCT =
  '/api/User/get-renewal-notification-grid/distinct';

export const GET_RENEWAL_NOTIFICATION_ACCEPTED_USERS_GRID =
  '/api/User/get-renewal-notification-accepted-users-grid';

export const GET_RENEWAL_NOTIFICATION_ACCEPTED_USERS_GRID_DISTINCT =
  '/api/User/get-renewal-notification-accepted-users-grid/distinct';

export const EXPORT_RENEWAL_NOTIFICATION_ACCEPTED_USERS =
  '/api/User/export-renewal-notification-accepted-users';
